module.exports = __webpack_public_path__ + "img/full-interworx-1.c08c2634.jpg";